import React, { useState, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import Hero from "../Utilities/Hero/Hero";
import Routes from "../Routes/Routes";

function Home({
  setView,
  setItem,
  loading,
  hasSearched,
  //
  handleSubmit,
  setPickup,
  setDrop,
  setDate,
  pickup,
  drop,
  date,
  allBusses,
  title,
  seatSelect,
  onViewResults,
}) {

  return (
    <React.Fragment>
      <Hero
        loading={loading}
        hasSearched={hasSearched}
        onViewResults={onViewResults}
        handleSubmit={handleSubmit}
        setPickup={setPickup}
        setDrop={setDrop}
        setDate={setDate}
        pickup={pickup}
        drop={drop}
        date={date}
      />
      <Routes
        setView={setView}
        setItem={setItem}
        allBusses={allBusses}
        loading={loading}
        title={title}
        seatSelect={seatSelect}
        hasSearched={hasSearched}
        pickup={pickup}
        drop={drop}
        date={date}
      />
    </React.Fragment>
  );
}

export default Home;
